module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/flag-9a3c025133c814cc4cccc0dcd23db852.svg&quot;;"